import React, { FC, useContext } from 'react';

import { Toggle } from '@smartshell/ui-kit';

import { SettingsLock } from 'components';
import { useIsFeatureAvailable } from 'features';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const AutostartPerminuteTariff: FC = () => {
  const { t } = useContext(LocalizationContext);
  const isAvailable = useIsFeatureAvailable('auto_per_minute');
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        onChange={(value: string) =>
          setSetting({
            alias: ESettingsAliases.SHELL_PER_MINUTE_ON_LOGIN,
            value: value ? '1' : '0',
          })
        }
        value={settings.runPerMinuteOnLogin}
        label={t('settings.billing.tariffs.autostart.label')}
        description={t('settings.billing.tariffs.autostart.description')}
        variant="secondary"
        emptyBg
        rightContent={!isAvailable ? <SettingsLock /> : undefined}
        disabled={!isAvailable}
      />
    </>
  );
};
